<template>
  <div class="row first hidden tablet:flex">
    <div v-for="n in 7" :key="n">
      <img :src="`/images/ingredients/${n}.png`" />
    </div>
  </div>
  <div class="row last hidden tablet:flex">
    <div v-for="n in 8" :key="n">
      <img :src="`/images/ingredients/${n + 7}.png`" />
    </div>
  </div>
  <div class="mobile-container tablet:hidden">
    <div
      class="mobile-row"
      :class="{
        first: index === 0,
      }"
      v-for="(i, index) in mobileRows"
      :key="index"
    >
      <div v-for="j in i" :key="j">
        <img :src="`/images/ingredients/${j}.png`" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const mobileRows = ref([
  [1, 2, 3],
  [4, 5, 6, 7],
  [8, 9, 10, 11],
  [12, 13, 14, 15],
]);
</script>

<style scoped lang="scss">
.row {
  //display: flex;
  justify-content: space-between;
  height: 210px;
  margin-left: -15px;

  & > * {
    padding-left: 15px;
  }

  @media screen and (min-width: 1024px) {
    margin-left: -15px;

    & > * {
      padding-left: 15px;
    }
  }

  &.first {
    & > *:nth-child(odd) {
      align-self: center;
    }
    & > *:nth-child(even) {
      align-self: flex-end;
    }
  }
  &.last {
    margin-top: 40px;

    & > *:nth-child(odd) {
      align-self: flex-start;
    }
    & > *:nth-child(even) {
      align-self: flex-end;
    }
  }
}

.mobile-container {
  margin-left: -15px;
}

.mobile-row {
  display: flex;
  justify-content: space-between;
  height: 35vw;
  //margin-left: -15px;

  & + .mobile-row {
    margin-top: 32px;
  }

  &:nth-child(1) {
    width: 80%;
    margin: 0 auto;

    & > *:nth-child(odd) {
      //align-self: flex-start;
      align-self: center;
    }
    & > *:nth-child(even) {
      align-self: flex-end;
    }
  }

  &:nth-child(2) {
    & > *:nth-child(odd) {
      align-self: flex-end;
    }
    & > *:nth-child(even) {
      align-self: flex-start;
    }
  }

  &:nth-child(3),
  &:nth-child(4) {
    & > *:nth-child(odd) {
      align-self: flex-start;
    }
    & > *:nth-child(even) {
      align-self: flex-end;
    }
  }

  & > * {
    padding-left: 15px;
  }
}
</style>
